<template lang="pug">
v-app-bar(
  ref="header",
  :class="$route.path === '/' ? 'transparent elevation-0' : 'primary'",
  :absolute="$route.path === '/'",
  height="94"
)
  v-container.d-flex.justify-center.align-center.main-header-desktop-wrap
    router-link.white--text.h-100(to="/")
      img.main-header-desktop-logo(:src="logo", contain, height="100%")
    nav-menu(:menu="menu")
</template>

<script>
import NavMenu from "./NavMenu";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    logo() {
      return this.files + this.$rest("informations").item.img;
    },
  },
  components: {
    NavMenu,
  },
};
</script>

<style>
.v-app-bar {
  z-index: 999;
}
.main-header-desktop-wrap {
  gap: 80px;
}
.main-header-desktop-logo {
  max-height: 70px;
}
.v-app-bar--is-scrolled {
  transform: translateY(-56px) !important;
}
</style>
